import { StyleSheet, type TextStyle } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCheckoutHeroStyleDefs = {
  checkoutHeroBlockCompact: {
    gap: spacing.xs,
  },

  checkoutHeroKicker: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink3,
    letterSpacing: 0.4,
    fontFamily: ticketFonts.sans,
  },

  checkoutRegisterTotal: {
    fontSize: 40,
    fontWeight: '700',
    lineHeight: 44,
    letterSpacing: -1.2,
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    fontFamily: ticketFonts.mono,
  },

  checkoutPayHeroHint: {
    marginTop: 6,
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ok,
    fontFamily: ticketFonts.sans,
  },

  checkoutTotalHero: {
    alignItems: 'stretch',
    flexDirection: 'column',
    paddingTop: 4,
    paddingBottom: 2,
  },

  checkoutTotalHeroMain: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },

  checkoutTotalHeroMetaStack: {
    marginTop: spacing.xs,
    gap: spacing.xs,
    paddingTop: spacing.xs,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
  },

  checkoutTotalHeroMetaStackFlush: {
    marginTop: spacing.sm,
  },

  checkoutAppliedPromosPanel: {
    marginTop: spacing.sm,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: spacing.sm,
    gap: spacing.xs,
    maxWidth: '100%',
  },

  checkoutAppliedPromosHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
    minWidth: 0,
  },

  checkoutAppliedPromosHeaderMain: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },

  checkoutAppliedPromosPreviewName: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
  },

  checkoutAppliedPromosHeaderTrailing: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    flexShrink: 0,
  },

  checkoutAppliedPromosDiscountAmount: {
    ...typography.caption,
    color: ticketColors.ok,
    fontWeight: '800',
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    fontFamily: ticketFonts.mono,
  },

  checkoutAppliedPromosList: {
    gap: 2,
    paddingTop: spacing.xs,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
  },

  checkoutAppliedPromosScroll: {
    maxHeight: 78,
    paddingTop: spacing.xs,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
  },

  checkoutAppliedPromosScrollContent: {
    gap: 2,
    paddingRight: 2,
  },

  checkoutTotalHeroMetaRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },

  checkoutTotalHeroMetaLabel: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '700',
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    flexShrink: 0,
    fontFamily: ticketFonts.sans,
  },

  checkoutTotalHeroMetaValue: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
    flex: 1,
    textAlign: 'right',
    lineHeight: 17,
    fontFamily: ticketFonts.sans,
  },

  checkoutHeroBadge: {
    borderRadius: 999,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
    paddingHorizontal: 10,
    paddingVertical: 4,
    alignSelf: 'flex-start',
    marginTop: 2,
  },

  checkoutHeroBadgeText: {
    fontSize: 11,
    fontWeight: '800',
    color: ticketColors.gold,
    fontFamily: ticketFonts.sans,
  },

  checkoutAlertsBand: {
    gap: spacing.sm,
    marginBottom: spacing.xs,
  },
} as const;
